module.exports = __webpack_public_path__ + "static/img/run.e70045b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/month/run.png
// module id = txF1
// module chunks = 0